import React from 'react';
import type { ReactNode } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DragGhostLayer } from './DragGhostLayer';
import { DropFeedbackLayer } from './DropFeedbackLayer';
import { DropSlotRegistryProvider } from './drop-slot-registry';

export function EditorDndProvider({ children }: { children: ReactNode }) {
  return (
    <DndProvider backend={HTML5Backend}>
      <DropSlotRegistryProvider>
        {children}
        <DragGhostLayer />
        <DropFeedbackLayer />
      </DropSlotRegistryProvider>
    </DndProvider>
  );
}
